/**
 * Built-in effect `radialBlur` (W2-01b; P§5.2): zoom blur toward (`centerX`, `centerY`) in uv (0..1, bottom-left
 * origin). Reimplemented from the behaviour (badged approximate).
 *
 * Each pixel averages `sampleCount` (1..64) reads stepping toward the centre; step k is k * `power` of the way, so
 * the streaks grow with the distance from the centre. 1 sample = unchanged.
 */

import { m } from './builtinFx.messages';
import { defineBuiltin, SAMPLE_SCREEN } from './shared';

export const radialBlur = defineBuiltin({
  name: 'radialBlur',
  label: { key: m.radialBlur },
  description: { key: m.radialBlurDesc },
  inputs: [],
  uniforms: [
    { name: 'centerX', type: 'float', default: 0.5, hint: '0..1', min: 0, max: 1, label: { key: m.radialBlurCenterX } },
    { name: 'centerY', type: 'float', default: 0.5, hint: '0..1', min: 0, max: 1, label: { key: m.radialBlurCenterY } },
    { name: 'power', type: 'float', default: 0.01, hint: '0..1', min: 0, max: 1, label: { key: m.radialBlurPower } },
    {
      name: 'sampleCount',
      type: 'float',
      default: 6,
      hint: 'int 1..64',
      min: 1,
      max: 64,
      integer: true,
      label: { key: m.radialBlurSampleCount },
    },
  ],
  helpers: [SAMPLE_SCREEN],
  main: `
void main() {
  vec2 toCentre = vec2(centerX, centerY) - uv;
  float n = clamp(floor(sampleCount + 0.5), 1.0, 64.0);
  vec4 acc = vec4(0.0);
  for (int i = 0; i < 64; i++) {
    float fi = float(i);
    if (fi >= n) break;
    acc += sampleScreen(uv + toCentre * power * fi);
  }
  gl_FragColor = acc / n;
}`,
});
